let startTime = 0;

const startSession = () => {
    startTime = new Date().getTime();
};

const getElapsedMillis = () => {
    return new Date().getTime() - startTime;
};

export default {
    startSession,
    getElapsedMillis
};
